import React, { CSSProperties } from 'react';

interface QuestionCircleProps {
  fill?: string;
  secondaryfill?: string;
  width?: string;
  height?: string;
  style?: CSSProperties;
  className?: string;
}

const QuestionCircle: React.FC<QuestionCircleProps> = ({ fill = 'currentColor', secondaryfill, width = '100%', height = '100%', style, className }) => {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 1060 1060" xmlns="http://www.w3.org/2000/svg" style={style}>
      <g>
        <circle cx="530" cy="530" r="313" fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50px" />
        <circle cx="532.5" cy="688.62" r="26.56" fill={fill} />
      </g>
      <path d="M425.42,430.05s0-89.24,107.08-89.24,107.08,89.24,107.08,89.24c0,0,0,44.62-53.54,89.24-53.54,44.62-53.54,89.24-53.54,89.24" fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50px" />
    </svg>
  );
};

export default QuestionCircle;
